// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-c7a8ce80]::-webkit-outer-spin-button,\ninput[data-v-c7a8ce80]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-c7a8ce80] {\n  -moz-appearance: textfield;\n}\n.base-dropdown__popper[data-v-c7a8ce80] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
